import React, {Fragment} from "react";

import './FormInputCheckbox.scss' ;

const FormInputCheckbox = ( { register, onChange, readOnly, label, sectionName, name, style, className, value } ) =>
{
    const classText = className === undefined ? "form-field" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const isHookForm = register !== undefined ;

    const clickHandler = ( event ) =>
    {
        onChange ( event.target.checked ) ;
    }

    return (
        <div className={classText} style={styleObj}>
            { isHookForm === true &&
                <Fragment>
                    <div className='form-check'>
                    <input className="form-check-input" disabled={readOnly} type="checkbox" {...register(sectionName + '.' + name, {})} />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                        { label }
                    </label>
                    </div>
                </Fragment>
            }
            { isHookForm === false && <input disabled={readOnly} type="checkbox" checked={value} onChange={clickHandler}/> }
        </div>
    )
}

export { FormInputCheckbox };